var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVxFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 193 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25293 0H5.42607L12.1276 18.5744L18.8586 0H23.7672L14.4203 24H9.59986L0.25293 0Z",
    fill: "#58595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7661 0H41.991V3.57093H30.5571V9.93772H40.9328V13.5086H30.5571V20.4567H41.991V24.0277H25.7661V0Z",
    fill: "#58595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9883 0H53.7774C60.7435 0 64.6234 2.32526 64.6234 6.61592C64.6234 9.85467 62.1544 11.9862 57.9218 12.4567V12.5398C61.978 12.8166 63.9179 14.3114 63.9179 18.2145V19.8477C63.9179 21.7024 64.3 23.0035 65.0642 24H60.0969C59.3914 23.2249 59.0093 22.0346 59.0093 20.2076V18.5467C59.0093 15.308 57.7454 14.1453 54.4534 14.1453H50.8087V24H45.9883V0ZM50.8087 3.40484V10.8789H53.6598C57.5985 10.8789 59.4796 9.71626 59.4796 7.14187C59.4796 4.56747 57.5985 3.40484 53.6598 3.40484H50.8087Z",
    fill: "#58595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8806 0H80.7011L90.0774 24H84.9336L83.1407 18.9066H73.2941L71.4423 24H66.5337L75.8806 0ZM74.3816 15.5848H82.1119L78.2614 4.92734L74.3816 15.5848Z",
    fill: "#58595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9282 3.57093H86.3154V0H106.361V3.57093H98.7486V24H93.9282V3.57093Z",
    fill: "#58595B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.621 0H118.442L127.818 24H122.674L120.852 18.9066H111.005L109.154 24H104.245L113.621 0ZM112.122 15.5848H119.853L116.002 4.92734L112.122 15.5848Z",
    fill: "#58595B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.817 0H138.841C146.6 0 151.715 4.95502 151.715 11.9862C151.715 19.0173 146.571 23.9723 138.841 23.9723H129.817V0ZM134.637 3.48789V20.4844H138.605C143.808 20.4844 146.6 17.3841 146.6 11.9862C146.6 6.56055 143.808 3.48789 138.605 3.48789H134.637Z",
    fill: "#58595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 0H150.598L159.827 24H163.677L163.619 15.5848L158.446 0Z",
    fill: "#2891B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.792 0L163.619 15.5848L163.677 24H167.087L173.495 7.28028L168.998 0H168.792Z",
    fill: "#143A52"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.081 0H176.317H168.998L173.495 7.28028L176.287 11.7647L168.645 24H176.375L180.079 17.0519L180.725 6.31142L177.081 0Z",
    fill: "#7EDBFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.458 11.6263L191.748 0H184.047L180.725 6.31142L180.079 17.0519L183.988 24H192.1L184.458 11.6263Z",
    fill: "#4EBCEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVxFullLogo);
export default __webpack_public_path__ + "static/media/vx-full-logo.22c69393f9f60a51cd443a2e780e1414.svg";
export { ForwardRef as ReactComponent };